// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3nnzK","description":"PatientConsentPreview_description__1czuM"};